import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AnimationStyle from '../styles/pages/Animations.module.scss'
import Loader from '../components/layout/Loader'
import { Box, Typography, List, ListItem , Avatar} from '@mui/material'
import arrow from '../shared/images/arrow-down.svg'
import arrowLeft from '../shared/images/icon-arrow-left.svg'
// - IMPORT API
import { useGetAllAnimationsQuery } from '../services/AnimationsAPI'
import { SingleAnimation } from '../utils/Interface'
import { useTranslation } from 'react-i18next';
const AnimationsPage: React.FC = () => {
    const { t, i18n  } = useTranslation();
    const {
        data: animationsData,
        error: animationsError,
        isLoading: animationsLoading,
        refetch
    } = useGetAllAnimationsQuery(/*{
        quantity: 3,
        sortBy: 'asc'
    }*/)


     // Utilisation de useEffect pour relancer la requête chaque fois que le composant est monté
  useEffect(() => {
    refetch(); // Rafraîchit les données à chaque fois que la page est visitée
  }, [refetch]);

    // - Check
    if (animationsError) {
        console.log(animationsError)
        console.log(animationsData)
        return <div>Error occurred while fetching restaurants.</div>
    }

    // - Wait until the data is loaded
    if (animationsLoading) {
        return <Loader />
    }

    // - Parse
    // - Filter for future animations
    const futureAnimations = animationsData?.data.filter((item: SingleAnimation) => {
        const animationDate = new Date(item.date).getTime()
        return animationDate > Date.now() && item.cancelled !== true
    })

    return (
        <div className={AnimationStyle.AnimationsContainer}>
            <div className={AnimationStyle.TopContainer}>
                <Link to='/mon-compte'>
                    <button className={AnimationStyle.arrowButton}>
                        <img src={arrowLeft} alt='Arrow Left' />
                    </button>
                </Link>
                <h2>{t('our_animations')}</h2>
                
            </div>
            <div className={AnimationStyle.CardContainer}>
                {Array.isArray(futureAnimations) && futureAnimations.length > 0 ? (
                    futureAnimations.map((item: SingleAnimation, index) => (
                        <>
                        <p className={AnimationStyle.Intro}>{t('our_animations_sub')}</p>
                        <ListItem
                            key={index}
                            className={AnimationStyle.AnimationItem}
                            component={Link}
                            to={`/reserve-animation/${item.id}`}
                        >
                            <div className={AnimationStyle.AnimationContent}>
                                <img
                                    src={String(String(process.env.REACT_APP_BASE_URL) + item.images?.[0]?.url) || 'default-image.png'}
                                    alt={item.title}
                                    className={AnimationStyle.AnimationImage}
                                />
                                <div className={AnimationStyle.AnimationInfo}>
                                    <div className={AnimationStyle.Lieu}>Les Settons</div>
                                    <div>
                                    <Typography variant="body2" className={AnimationStyle.strong}>{item.title}</Typography>
                                    <Typography variant="body2" className={AnimationStyle.thin}>
                                        {new Date(item.date).toLocaleDateString(i18n.language, {
                                            day: 'numeric',
                                            month: 'short',
                                        })}{' '}
                                        - {new Date(item.date).toLocaleTimeString(i18n.language, {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        })}
                                    </Typography>
                                    <Typography variant="body2" className={AnimationStyle.thin}>
                                    {item.nbParticipants} {item.nbParticipants <= 1 ? t('participant') : t('participant') + 's'}
                                    </Typography>

                                    </div>
                                    <Typography variant="body2" className={AnimationStyle.strong}>{t('free')}</Typography>
                                </div>
                            </div>
                            <img src={arrow} alt='arrow' className={AnimationStyle.ArrowIcon} />
                        </ListItem>
                        </>
                    ))
                ) : (
                    <Typography variant="body2" className={AnimationStyle.noAnimationsMessage}>
                        {t('no_animation')}
                    </Typography>
                )}
            </div>
        </div>
    )
}

export default AnimationsPage